<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="smalltitle">Credentials</div>
            <i>Please upload your credentials here. These information will show at your profile at the clinic(s) you are associated with.</i>

            <div class="currentlist">
                <p style="text-align: center" v-if="listFiles.length === 0">No file</p>
                <ul class="itemlisttable providerlist" v-if="listFiles.length > 0">
                    <li class="itemlisthead">
                        <div style="width: 15%!important;">Type</div>
                        <div style="width: 17%!important; padding-left: 0px !important; text-align: center !important;">
                            License Number
                        </div>
                        <div style="width: 20%!important; text-align: center;">Expiration</div>
                        <div style="width: 10%!important; text-align: center;">State</div>
                        <div style="width: 15%!important; text-align: center;">Main License</div>
                        <div style="width: 15%!important; text-align: right;">File uploaded</div>
                    </li>
                    <li v-for="item in listFiles">
                        <div style="width: 15%!important; min-height: 1px; padding-top: 0px !important;  min-height: 1px;">
                            {{getTypeFile(item)}}
                        </div>
                        <div style="width: 17%!important; text-align: center !important;; padding-top: 0px !important;  min-height: 1px;">
                            {{item.type_number}}
                        </div>
                        <div style="width: 20%!important; text-align: center; padding-top: 0px; padding-top: 0px !important;  min-width: 1px;">
                            {{formatTime(item.expiration_date) }}
                        </div>
                        <div style="width: 10%!important; text-align: center;
                             padding-top: 0px; min-height: 1px; padding-top: 0px !important; min-height: 1px;">
                            {{item.state}}
                        </div>
                        <div style="width: 15%!important; text-align: center; min-height: 1px; padding-top: 0px !important;">
                            <i class="fas fa-check-circle"
                               v-if="item.type !== 'abai_copy' && item.type !== 'abai' && item.main_number">
                            </i>
                        </div>
                        <div :title="item.file_name"
                             style="width: 15%!important; text-align: right; padding-top: 0px; padding-top: 0px !important;">
                            <a href="javascript:void(0);"
                               @click="previewFile(item)">{{item.file_name}}</a>
                        </div>

                    </li>
                </ul>
            </div>

        </div>
        <preview-pdf
                v-if="previewPdf.modal"
                :linkPreview="previewPdf.link"
                @updateModal="previewPdf.modal = $event">
        </preview-pdf>
    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'
import PreviewPdf from '../../../../global/PreviewPdf'

export default {
  name: 'TabAccountSetting',
  components: { PreviewPdf },
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      listFiles: [],
      previewPdf: {
        modal: false,
        link: ''
      }
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    this.getListFiles()
  },
  beforeDestroy () {
  },
  methods: {
    previewFile (item) {
      this.previewPdf.link = item.link
      this.previewPdf.modal = true
    },
    getTypeFile (item) {
      if (item.type === 'medical_license') {
        return 'Medical License'
      }

      if (item.type === 'dea') {
        return 'DEA'
      }

      if (item.type === 'abai' || item.type === 'abai_copy') {
        return 'ABAI'
      }

      return item.type
    },
    async getListFiles () {
      try {
        let response = await httpClient.get('/users/electronic-medical', { params: { userId: this.userInfo.id } })
        if (response.data.s === 200) {
          this.listFiles = response.data.data.files
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
